import { useCallback, useState } from "react";

type ModalOpenCallback = () => void;
type ModalCloseCallback = () => void;

export function useModalState(
  defaultOpen = false,
): [boolean, ModalOpenCallback, ModalCloseCallback] {
  const [modalOpened, setModalOpened] = useState(defaultOpen);
  const onModalClose = useCallback(() => setModalOpened(false), []);
  const onModalOpen = useCallback(() => setModalOpened(true), []);

  return [modalOpened, onModalOpen, onModalClose];
}
